export default {
  install: (app) => {
    let convertToSlug = (title, id, type = "") => {
      return (
        type +
        title
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "") +
        "-" +
        id
      );
    };

    app.config.globalProperties.$convertToSlug = (title, id) => {
      return convertToSlug(title, id);
    };

    app.config.globalProperties.$buildProductURL = (title, id) => {
      return convertToSlug(title, id, process.env.VUE_APP_PRODUCT_PATH);
    };
    app.config.globalProperties.$buildBlogURL = (title, id) => {
      return convertToSlug(title, id, process.env.VUE_APP_BLOG_PATH);
    };
    app.config.globalProperties.$buildVendorURL = (vendor, fallbackId = "") => {
      const ensureLeadingSlash = (value) =>
        value.startsWith("/") ? value : `/${value}`;

      if (!vendor) {
        return ensureLeadingSlash("vendors");
      }

      if (typeof vendor === "object") {
        const containerPath = vendor?.containerPath;
        if (containerPath) {
          return ensureLeadingSlash(`vendors/${containerPath}`);
        }

        const name =
          vendor?.denominazioneSociale ||
          vendor?.ragioneSociale ||
          vendor?.nome ||
          vendor?.name ||
          "";
        const id = vendor?._id || fallbackId;

        if (name && id) {
          return convertToSlug(name, id, ensureLeadingSlash("vendors/"));
        }

        if (id) {
          return ensureLeadingSlash(`vendors/${id}`);
        }

        if (name) {
          return ensureLeadingSlash(
            `vendors/${name
              .toLowerCase()
              .replace(/ /g, "-")
              .replace(/[^\w-]+/g, "")}`
          );
        }
        return ensureLeadingSlash("vendors");
      }

      return ensureLeadingSlash(`vendors/${vendor}`);
    };
  },
};
